// Mailto link
export const SUPPORT_MAILTO = 'mailto:support@whenwemeet.xyz';

// Mailto link with pre-filled subject and body template for feedback
export const FEEDBACK_MAILTO =
  'mailto:support@whenwemeet.xyz?subject=Feedback%20-%20WhenWeMeet&body=Hi%20WhenWeMeet%20team%2C%0A%0AType%20your%20feedback%20details%20below.%0A%0A-%20Screen%3A%20%0A-%20Platform%20%28e.g.%20iOS%2026%20or%20Android%2016%29%3A%20%0A-%20Screenshots%20%28optional%29%3A%20%0A%0AThanks';

// Mailto link with pre-filled subject and body template for bug reports
export const BUG_REPORT_MAILTO =
  'mailto:support@whenwemeet.xyz?subject=Bug%20Report%20-%20WhenWeMeet&body=Hi%20WhenWeMeet%20team%2C%0A%0AType%20your%20bug%20details%20below.%20Please%20include%20steps%20to%20reproduce%2C%20what%20you%20expected%2C%20and%20what%20happened.%0A%0A-%20Screen%3A%20%0A-%20Platform%20%28e.g.%20iOS%2026%20or%20Android%2016%29%3A%20%0A-%20Screenshots%20%28optional%29%3A%20%0A%0AThanks';

// Accessibility text for the feedback link
export const FEEDBACK_ARIA_LABEL = 'Give feedback via email';
export const FEEDBACK_TITLE = 'Give feedback via email';

// Accessibility text for the bug report link
export const BUG_REPORT_ARIA_LABEL = 'Report a bug via email';
export const BUG_REPORT_TITLE = 'Report a bug via email';

// Support Us link
export const SUPPORT_US_URL = 'https://buymeacoffee.com/whenwemeet';
// Accessibility text for the Support Us link
export const SUPPORT_US_ARIA_LABEL = 'Support us via BuyMeACoffee';
export const SUPPORT_US_TITLE = 'Support us via BuyMeACoffee';

export const PRIVACY_POLICY_URL =
  'https://www.freeprivacypolicy.com/live/1d85b1dc-1f90-447a-97d3-f2f893a5e2f8';
export const TERMS_OF_SERVICE_URL =
  'https://www.freeprivacypolicy.com/live/7719e51c-4e0b-4340-9d39-c3cdacc89c36';

// App Store links
export const APP_STORE_URL =
  'https://apps.apple.com/us/app/whenwemeet-group-scheduling/id6756392167';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.wongpiwat.whenwemeet';

// LinkedIn
export const LINKEDIN_URL = 'https://www.linkedin.com/company/whenwemeet/';

// YouTube
export const YOUTUBE_URL = 'https://www.youtube.com/@WhenWeMeet-App';
